import React from 'react';
import { func, any, bool } from 'prop-types';
import { WithLoading } from '@widergy/energy-ui';

import { accountPropTypes } from 'redux/accountHandlers';
import { billPropTypes, billProgressPropTypes } from 'types/billTypes';

import AccountSelector from './components/AccountSelector';
import BillsDetails from './components/BillsDetails';
import styles from './styles';

function AccountStatus({
  onChangeAccount,
  onGoToAccounts,
  onDownloadBill,
  onDownloadPaymentDocument,
  currentAccount,
  accounts,
  currentBill,
  billProgress,
  loadingAccount,
  loadingBill,
  consumptionHistory
}) {
  return (
    <div style={styles.container}>
      <AccountSelector
        onChangeAccount={onChangeAccount}
        onGoToAccounts={onGoToAccounts}
        currentAccount={currentAccount}
        accounts={accounts}
        loading={loadingAccount}
      />
      <BillsDetails
        currentAccount={currentAccount}
        bill={currentBill}
        progress={billProgress}
        loading={loadingBill}
        onDownloadBill={onDownloadBill}
        onDownloadPaymentDocument={onDownloadPaymentDocument}
        consumptionHistory={consumptionHistory}
      />
    </div>
  );
}

AccountStatus.propTypes = {
  onChangeAccount: func.isRequired,
  onGoToAccounts: func.isRequired,
  onDownloadBill: func.isRequired,
  currentAccount: accountPropTypes,
  accounts: accountPropTypes,
  currentBill: billPropTypes,
  billProgress: billProgressPropTypes,
  consumptionHistory: any, // eslint-disable-line react/forbid-prop-types
  loadingAccount: bool.isRequired,
  loadingBill: bool.isRequired,
  onDownloadPaymentDocument: func
};

export default WithLoading(props => props.loadingAccount)(AccountStatus);
